import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { GiftCardOrder } from '@app/models/GiftCard';

@Component({
  selector: 'app-gift-card-modal',
  standalone: false,
  templateUrl: './giftCard.component.html',
  styleUrl: './giftCard.component.scss',
})
export class GiftCardModalComponent {
  giftCard: GiftCardOrder = {
    orderId: '',
    name: '',
    contactDetails: {
      buyerName: '',
      buyerEmail: '',
      buyerPhone: '',
      buyerStreet: '',
      buyerHouseNumber: '',
      buyerPostalCode: '',
      buyerCity: '',
      buyerCountry: '',
      recipientName: '',
      recipientEmail: '',
      recipientPhone: '',
      recipientStreet: '',
      recipientHouseNumber: '',
      recipientPostalCode: '',
      recipientCity: '',
      recipientCountry: '',
    },
    amount: 0,
    quantity: 1,
    message: '',
    status: 'que',
  };

  amounts = [25, 50, 100, 250, 500];

  constructor(
    private dialog: DialogRef<GiftCardOrder>,
    @Inject(DIALOG_DATA) public data: { amount: number },
  ) {
    this.giftCard.amount = this.data.amount;
  }

  selectAmount(amount: number): void {
    this.giftCard.amount = amount;
  }

  decreaseQuantity(): void {
    this.giftCard.quantity = Math.max(1, this.giftCard.quantity - 1);
  }

  increaseQuantity(): void {
    this.giftCard.quantity = Math.min(20, this.giftCard.quantity + 1);
  }

  submit(form: NgForm): void {
    if (form.invalid) {
      form.control.markAllAsTouched();
      return;
    }

    const buyerName = this.giftCard.contactDetails.buyerName.trim();
    const buyerEmail = this.giftCard.contactDetails.buyerEmail
      .trim()
      .toLowerCase();
    const buyerPhone = this.giftCard.contactDetails.buyerPhone.trim();
    const buyerStreet = this.giftCard.contactDetails.buyerStreet.trim();
    const buyerHouseNumber =
      this.giftCard.contactDetails.buyerHouseNumber.trim();
    const buyerPostalCode = this.giftCard.contactDetails.buyerPostalCode.trim();
    const buyerCity = this.giftCard.contactDetails.buyerCity.trim();
    const buyerCountry = this.giftCard.contactDetails.buyerCountry.trim();
    const recipientName = this.giftCard.contactDetails.recipientName.trim();
    const recipientEmail = this.giftCard.contactDetails.recipientEmail
      .trim()
      .toLowerCase();
    const recipientPhone = this.giftCard.contactDetails.recipientPhone.trim();
    const recipientStreet = this.giftCard.contactDetails.recipientStreet.trim();
    const recipientHouseNumber =
      this.giftCard.contactDetails.recipientHouseNumber.trim();
    const recipientPostalCode =
      this.giftCard.contactDetails.recipientPostalCode.trim();
    const recipientCity = this.giftCard.contactDetails.recipientCity.trim();
    const recipientCountry =
      this.giftCard.contactDetails.recipientCountry.trim();

    if (
      !this.giftCard.name?.trim() ||
      !buyerName ||
      !buyerEmail ||
      !buyerPhone ||
      // !buyerStreet ||
      // !buyerHouseNumber ||
      // !buyerPostalCode ||
      // !buyerCity ||
      // !buyerCountry ||
      !recipientName ||
      !recipientEmail ||
      !recipientPhone ||
      // !recipientStreet ||
      // !recipientHouseNumber ||
      // !recipientPostalCode ||
      // !recipientCity ||
      // !recipientCountry ||
      !Number.isFinite(Number(this.giftCard.amount)) ||
      this.giftCard.quantity < 1
    ) {
      return;
    }

    this.dialog.close({
      ...this.giftCard,
      name: this.giftCard.name.trim(),
      message: this.giftCard.message.trim(),
    });
  }

  closeModal(): void {
    console.log('reached here');
    this.dialog.close();
  }

  get total(): number {
    return this.giftCard.amount * this.giftCard.quantity;
  }
}
